import { MoreHoriz } from "@mui/icons-material";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useRef, useState } from "react";
import { IconBase } from "react-icons";
import DeletePost from "./DeletePost";
import RestrictPost from "./RestrictPost";
import _cookies from "../../../shared/utils/_cookies";
import Repost from "./Repost";
import { EditPostImages } from "./EditPostImages";

export default function PostActions({ postData }) {
  const [buttonEl, setButtonEl] = useState();
  const optionIsOpen = Boolean(buttonEl);
  const handleClickOptions = (event) => {
    setButtonEl(event.currentTarget);
  };
  const handleCloseOptions = () => {
    setButtonEl(null);
  };
  const showDeleteButton = () => {
    return postData.alunoid == _cookies.getItem("auth").user.alunoid;
  };

  const showEditPictures = () => {
    return (
      postData.TipoPostagem === "IMAGEM" &&
      !!_cookies.getItem("auth").user?.profile?.isGestor?.ID
    );
  };

  const showRestrictButton = () => {
    return (
      postData.alunoid != _cookies.getItem("auth").user.alunoid &&
      !!_cookies.getItem("auth").user?.profile?.isGestor?.ID
    );
  };

  const showRepostButton = () => {
    return !(postData.alunoid == _cookies.getItem("auth").user?.alunoid);
  };
  const showActionsButton = () =>
    showDeleteButton() || showRestrictButton() || showRepostButton();

  return (
    <>
      {showActionsButton() ? (
        <IconButton
          className="post_actions_button"
          onClick={handleClickOptions}
        >
          <MoreHoriz />
        </IconButton>
      ) : (
        <></>
      )}
      <Menu
        anchorEl={buttonEl}
        open={optionIsOpen}
        onClose={handleCloseOptions}
      >
        {showDeleteButton() && (
          <DeletePost postData={postData} onSuccess={handleCloseOptions}>
            {({ openConfirmationDialog }) => {
              return (
                <MenuItem onClick={openConfirmationDialog}>
                  Excluir Post
                </MenuItem>
              );
            }}
          </DeletePost>
        )}
        {showRestrictButton() && (
          <RestrictPost postData={postData} onSuccess={handleCloseOptions}>
            {({ openConfirmationDialog }) => {
              return (
                <MenuItem onClick={openConfirmationDialog}>
                  Restringir post
                </MenuItem>
              );
            }}
          </RestrictPost>
        )}
        {showEditPictures() && (
          <EditPostImages postData={postData}>
            {({ openDialog }) => {
              return <MenuItem onClick={openDialog}>Editar imagens</MenuItem>;
            }}
          </EditPostImages>
        )}
      </Menu>
    </>
  );
}
